module.exports = __webpack_public_path__ + "img/GS_Profile-Antonio Botha.95d108a4.png";